const Modal = () => {
  const modalWrappers = [...document.querySelectorAll(".modal__wrapper")];
  const openers = [...document.querySelectorAll(".modal__opener")];

  openers.forEach(opener => {
    opener.addEventListener("click", () => {
      const modalType = opener.dataset.modalType;
      const modalWrapper = modalWrappers.find(wrapper => wrapper.dataset.modalType === modalType);
      if (modalWrapper) {
        modalWrapper.classList.add("opened");
      }
    });
  });

  modalWrappers.forEach((modalWrapper) => {
    const closerBtn = modalWrapper.querySelector(".modal__closer");
    closerBtn.addEventListener("click", () => {
      modalWrapper.classList.remove("opened");
    });

    document.addEventListener("click", (event) => {
      if (event.target === modalWrapper && !modalWrapper.querySelector(".modal").contains(event.target)) {
        modalWrapper.classList.remove("opened");
      }
    });
  });
};

export default Modal;
